var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199.125,
    height: 236.274,
    viewBox: "0 0 199.125 236.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "android",
    transform: "translate(146.6 73.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-143 -68.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(34.895 17.065)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 61.067,
    cy: 56.37,
    rx: 61.067,
    ry: 56.37,
    fill: "#a4c639",
    stroke: "#fff",
    strokeWidth: 14.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 122.134,
    height: 122.134,
    rx: 22,
    transform: "translate(0 42.277)",
    fill: "#a4c639",
    stroke: "#fff",
    strokeWidth: 14.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(191.925 227.78) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 8.724,
    height: 57.712,
    rx: 4.362,
    transform: "translate(104.179 177.304) rotate(-29)",
    fill: "#a4c639",
    stroke: "#fff",
    strokeWidth: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    width: 32.211,
    height: 89.252,
    rx: 16.106,
    transform: "translate(0 65.093)",
    fill: "#a4c639",
    stroke: "#fff",
    strokeWidth: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 32.211,
    height: 89.252,
    rx: 16.106,
    transform: "translate(57.041)",
    fill: "#a4c639",
    stroke: "#fff",
    strokeWidth: 7.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 8.724,
    height: 57.712,
    rx: 4.362,
    transform: "matrix(0.875, 0.485, -0.485, 0.875, 132.159, 0)",
    fill: "#a4c639",
    stroke: "#fff",
    strokeWidth: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c-2",
    "data-name": "c",
    width: 32.211,
    height: 89.252,
    rx: 16.106,
    transform: "translate(0 73.435)",
    fill: "#a4c639",
    stroke: "#fff",
    strokeWidth: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 32.211,
    height: 89.252,
    rx: 16.106,
    transform: "translate(57.041 138.528)",
    fill: "#a4c639",
    stroke: "#fff",
    strokeWidth: 7.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(34.895 17.065)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 61.067,
    cy: 56.37,
    rx: 61.067,
    ry: 56.37,
    fill: "#a4c639"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 122.134,
    height: 122.134,
    rx: 22,
    transform: "translate(0 42.277)",
    fill: "#a4c639"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(-110.789 -25.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-95,44.5H32.5",
    transform: "translate(95 -11.953)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.684,
    cy: 2.684,
    r: 2.684,
    transform: "translate(32.882 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 2.684,
    cy: 2.684,
    r: 2.684,
    transform: "translate(89.252 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 7.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.0cd46291a1877249811b8093bbc61641.svg";
export { ForwardRef as ReactComponent };